module.exports = __webpack_public_path__ + "img/5.ac96a9fd.png";